import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  HELP_DESK_TICKETS,
  HELP_DESK_TICKETS_ALL,
  HELP_DESK_TICKETS_LIST,
  HELP_DESK_TICKETS_OWN,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const HELP_DESK = GLOBAL_STATE

export const { reducer: helpDeskReducer } = createSlice({
  name: HELP_DESK,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.helpDeskTickets.pending, state => {
        state[HELP_DESK_TICKETS].loading = true
      })
      .addCase(actionCreators.helpDeskTickets.rejected, (state, action) => {
        state[HELP_DESK_TICKETS].loading = false
        state[HELP_DESK_TICKETS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.helpDeskTickets.fulfilled, (state, action) => {
        state[HELP_DESK_TICKETS].loading = false
        state[HELP_DESK_TICKETS].error = null
        state[HELP_DESK_TICKETS].data = action.payload
      })

    builder
      .addCase(actionCreators.helpDeskTicketsList.pending, state => {
        state[HELP_DESK_TICKETS_LIST].loading = true
      })
      .addCase(actionCreators.helpDeskTicketsList.rejected, (state, action) => {
        state[HELP_DESK_TICKETS_LIST].loading = false
        state[HELP_DESK_TICKETS_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.helpDeskTicketsList.fulfilled, (state, action) => {
        state[HELP_DESK_TICKETS_LIST].loading = false
        state[HELP_DESK_TICKETS_LIST].error = null
        state[HELP_DESK_TICKETS_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.helpDeskTicketsAll.pending, state => {
        state[HELP_DESK_TICKETS_ALL].loading = true
      })
      .addCase(actionCreators.helpDeskTicketsAll.rejected, (state, action) => {
        state[HELP_DESK_TICKETS_ALL].loading = false
        state[HELP_DESK_TICKETS_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.helpDeskTicketsAll.fulfilled, (state, action) => {
        state[HELP_DESK_TICKETS_ALL].loading = false
        state[HELP_DESK_TICKETS_ALL].error = null
        state[HELP_DESK_TICKETS_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.helpDeskTicketsOwn.pending, state => {
        state[HELP_DESK_TICKETS_OWN].loading = true
      })
      .addCase(actionCreators.helpDeskTicketsOwn.rejected, (state, action) => {
        state[HELP_DESK_TICKETS_OWN].loading = false
        state[HELP_DESK_TICKETS_OWN].error = action.payload as AxiosError
      })
      .addCase(actionCreators.helpDeskTicketsOwn.fulfilled, (state, action) => {
        state[HELP_DESK_TICKETS_OWN].loading = false
        state[HELP_DESK_TICKETS_OWN].error = null
        state[HELP_DESK_TICKETS_OWN].data = action.payload
      })

    builder.addCase(actionCreators.helpDeskTicketsClear, state => {
      state[HELP_DESK_TICKETS] = defaultState()
    })

    builder.addCase(actionCreators.helpDeskTicketsListClear, state => {
      state[HELP_DESK_TICKETS_LIST] = defaultState()
    })

    builder.addCase(actionCreators.helpDeskTicketsAllClear, state => {
      state[HELP_DESK_TICKETS_ALL] = defaultState()
    })

    builder.addCase(actionCreators.helpDeskTicketsOwnClear, state => {
      state[HELP_DESK_TICKETS_OWN] = defaultState()
    })
  },
})
